import { render, staticRenderFns } from "./DirectFileUpload.vue?vue&type=template&id=4d14dd4f&scoped=true&"
import script from "./DirectFileUpload.vue?vue&type=script&lang=ts&"
export * from "./DirectFileUpload.vue?vue&type=script&lang=ts&"
import style0 from "./DirectFileUpload.vue?vue&type=style&index=0&id=4d14dd4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d14dd4f",
  null
  
)

export default component.exports